import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
// import { duplicateTxn } from '../../../../../utils/JsonData/duplicateTxn';
import { duplicateTxn } from '../../../../../api/commonApis';
import { useSelector } from 'react-redux';





const DuplicateTxn = () => {

  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
  const [duplicatetxn, setDuplicatetxn] = useState(null);

  const columns = [
    {
      title: 'Transaction Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Particulars',
      dataIndex: 'particular',
      key: 'particular',
    },
    {
      title: 'Cheque / Ref Nbr',
      dataIndex: 'chequeNumber',
      key: 'chequeNumber',
    },
    {
      title: 'Debit (₹)',
      dataIndex: 'debit',
      key: 'debit',
    },
    {
      title: 'Credit (₹)',
      dataIndex: 'credit',
      key: 'credit',
    },
    {
      title: 'Balance (₹)',
      dataIndex: 'balance',
      key: 'balance',
    },
    {
      title: 'File Name',
      dataIndex: 'fileName',
      key: 'fileName',
    },
  ];

  useEffect(() => {

    const fetchData = async () => {
      try {
        const response = await duplicateTxn(selectedAccountId);

        setDuplicatetxn(response);

      } catch (error) {

        console.log("ERROR", error);
      }
    }

    if (selectedAccountId) fetchData();
  }, [selectedAccountId]);

  return (
    <Table
      columns={columns}
      dataSource={duplicatetxn?.duplicateTxns}
      pagination={true} 
    />
  );
};

export default DuplicateTxn;
